export default "__VITE_ASSET__6ks96yy1QHXrCmsAcgYUtw__"